export default {
  CHECK_IN: 'CHECK_IN',
  SCHEDULE_APPOINTMENT: 'SCHEDULE_APPOINTMENT',
  JOIN_WAITLIST: 'JOIN_WAITLIST',
}
